"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 18 18" id=icon-radio-unchecked-18><path fill-rule=evenodd clip-rule=evenodd d="M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18ZM9 1a8 8 0 1 0 0 16A8 8 0 0 0 9 1Z"></path></symbol>';
}
